/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceTypeSettingsResponse
 */
export interface DeviceTypeSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsResponse
     */
    deviceTypeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsResponse
     */
    fwExtraName1: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsResponse
     */
    fwExtraName2: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsResponse
     */
    fwExtraName3: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeSettingsResponse
     */
    loaderMaxRetries: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeSettingsResponse
     */
    fwMaxRetries: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeSettingsResponse
     */
    uiMaxRetries: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    eda: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsResponse
     */
    urlPreProd: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    allowDowngradeUr: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    allowUidUpdate: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    disableCheckSn: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    urSendAllAtOnce: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    disableTagUrl: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    enableDeploymentMode: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    addBPProfile: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    enableQuota: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    enableStbAuth: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsResponse
     */
    loaderBypass: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    enablelightReset?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    enablefullReset?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsResponse
     */
    enablereboot?: boolean | null;
}

export function DeviceTypeSettingsResponseFromJSON(json: any): DeviceTypeSettingsResponse {
    return DeviceTypeSettingsResponseFromJSONTyped(json, false);
}

export function DeviceTypeSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeSettingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deviceTypeId': json['deviceTypeId'],
        'fwExtraName1': json['fwExtraName1'],
        'fwExtraName2': json['fwExtraName2'],
        'fwExtraName3': json['fwExtraName3'],
        'loaderMaxRetries': json['loaderMaxRetries'],
        'fwMaxRetries': json['fwMaxRetries'],
        'uiMaxRetries': json['uiMaxRetries'],
        'eda': json['eda'],
        'urlPreProd': json['urlPreProd'],
        'allowDowngradeUr': json['allowDowngradeUr'],
        'allowUidUpdate': json['allowUidUpdate'],
        'disableCheckSn': json['disableCheckSn'],
        'urSendAllAtOnce': json['urSendAllAtOnce'],
        'disableTagUrl': json['disableTagUrl'],
        'enableDeploymentMode': json['enableDeploymentMode'],
        'addBPProfile': json['addBPProfile'],
        'enableQuota': json['enableQuota'],
        'enableStbAuth': json['enableStbAuth'],
        'loaderBypass': json['loaderBypass'],
        'enablelightReset': !exists(json, 'enablelightReset') ? undefined : json['enablelightReset'],
        'enablefullReset': !exists(json, 'enablefullReset') ? undefined : json['enablefullReset'],
        'enablereboot': !exists(json, 'enablereboot') ? undefined : json['enablereboot'],
    };
}

export function DeviceTypeSettingsResponseToJSON(value?: DeviceTypeSettingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceTypeId': value.deviceTypeId,
        'fwExtraName1': value.fwExtraName1,
        'fwExtraName2': value.fwExtraName2,
        'fwExtraName3': value.fwExtraName3,
        'loaderMaxRetries': value.loaderMaxRetries,
        'fwMaxRetries': value.fwMaxRetries,
        'uiMaxRetries': value.uiMaxRetries,
        'eda': value.eda,
        'urlPreProd': value.urlPreProd,
        'allowDowngradeUr': value.allowDowngradeUr,
        'allowUidUpdate': value.allowUidUpdate,
        'disableCheckSn': value.disableCheckSn,
        'urSendAllAtOnce': value.urSendAllAtOnce,
        'disableTagUrl': value.disableTagUrl,
        'enableDeploymentMode': value.enableDeploymentMode,
        'addBPProfile': value.addBPProfile,
        'enableQuota': value.enableQuota,
        'enableStbAuth': value.enableStbAuth,
        'loaderBypass': value.loaderBypass,
        'enablelightReset': value.enablelightReset,
        'enablefullReset': value.enablefullReset,
        'enablereboot': value.enablereboot,
    };
}

